<template>
<transition name="fade-in">
    <div class="user-info-wrapper">
      <div class="user-info">
        <p class="name">
          {{ name || '이름을 설정해주세요' }}
        </p>
        <p class="phone">
          {{ phone || '휴대폰 번호를 설정해주세요'}}
        </p>
        <p class="email">
          {{ email || '이메일 주소를 설정해주세요'}}
        </p>
      </div>

      <div class="button-group">
        <slot></slot>
      </div>
    </div>
</transition>
</template>

<script>
export default {
  name: 'Home',
  props: {
    name: String,
    phone: String,
    email: String,
  },
};
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  width: 100%;

  .user-info {
    margin-top: 12px;

    p {
      font-size: 16px;
      margin-bottom: 6px;

      &.name {
        width: 100%;
        white-space: nowrap;
        font-size: 20px;
        margin-bottom: 12px;
      }

      &.phone, &.email {
        width: 100%;
        color: $nd60;
      }
    }
  }

  .button-group {
    width: 100%;

    margin-top: 24px;
  }
}

@media screen and (max-width: 1024px) {
  .user-info-wrapper {

    .user-info {

      p {
        text-align: center;
      }
    }

    .button-group {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/spa/components/profile/layouts/Home.vue